// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"styles__gradient-bg5__xmBDB","inbox":"styles__inbox__QR4J8","rectangleAdContainer":"styles__rectangleAdContainer__si0Op","bottomAd":"styles__bottomAd__kPLM3"};